import { profile, edit_profile } from "@/module/Profile/locale/profile.en.js";
import { QRCode } from "@/module/ScanQRCode/locale/qrcode.en.js";
import { registerEn, survey } from '@/module/Register/locale/RegisterEn.js';
import { staticEn } from '@/module/Static/locale/StaticEn.js';
import { missionEn } from '@/module/Mission/locale/MissionEn.js';
import { luckydraw } from '@/module/Luckydraw/locale/luckydraw.en'
import { announce } from '../../module/Announcement/locale/announce.en'
export const en = {
    default: {
        search: 'SEARCH',
        confirm: 'CONFIRM',
        ok: 'OK',
        cancel: 'CANCEL',
    },
    qrcode: QRCode,
    profile,
    edit_profile,
    register: registerEn,
    survey: survey,
    static: staticEn,
    mission: missionEn,
    luckydraw: luckydraw,

    announce: announce,
    date: {
        days: 'day',
        months: 'month',
        years: 'year',
        minutes: 'minute',
        minutes_short: 'min',
        hours: 'hour',
        hours_short: 'hr',
        date_flase: 'Please select your birthday.',
        month_full: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        month_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        month_full_arr: [{ strvalue: "01", strtext: 'January' },
        { strvalue: '02', strtext: 'February' },
        { strvalue: '03', strtext: 'March' },
        { strvalue: '04', strtext: 'April' },
        { strvalue: '05', strtext: 'May' },
        { strvalue: '06', strtext: 'June' },
        { strvalue: '07', strtext: 'July' },
        { strvalue: '08', strtext: 'August' },
        { strvalue: '09', strtext: 'September' },
        { strvalue: '10', strtext: 'October' },
        { strvalue: '11', strtext: 'November' },
        { strvalue: '12', strtext: 'December' }]
    },
    redeem_button: {
        default: 'Redeem',
        none: '',
        soldOut: 'Sorry, This reward is reaching redemption limit.',
        soldOutBuy: 'Sorry, This reward is reaching redemption limit.',
        maxPerPerson: 'Sorry, You have already redeemed this reward.',
        redeemCoolDown: 'This campaign has been used for this period.',
        nextDate: '<br/>at : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'This campaign requires user action before redemption, please review the conditions first.',
        campaignExpired: 'Campaign has expired.',
        campaignExpiredBuy: 'Campaign has expired.',
        campaignNotAvailable: 'Sorry. This reward is not available',
        campaignNotAvailableBuy: 'Sorry. This product is not available',
        notEnoughPoint: 'Your point are not enough to redeem this campaign.',
        notSupport: 'This campaign is not support.',
        review_product: 'รีวิวผลิตภัณฑ์',
        survey: 'ทำแบบสอบถาม',
        donate: 'ลุ้นรางวัล',
        not_enough_points: 'คะแนนไม่พอลุ้นรางวัล',
    },
    confirm_redeem: {
        confirm: "Confirm",
        cancel: "Cancel",

        headline: 'Confirm',
        draw_headline: 'ยืนยันการลุ้นรางวัล',
        surveydraw_headline: 'ยืนยันการร่วมกิจกรรม',
        donate_headline: 'ยืนยันการลุ้นรางวัล',
        default: 'confirm to use point',
        default_question: 'to redeem?',
        default_question_donate: 'ในการลุ้นรางวัลใช่หรือไม่?',
        default_survey: 'คุณจะได้รับพอยท์',
        default_survey_question: 'หลังจากตอบแบบสอบถามสำเร็จแล้ว',
        default_survey_approve_question: 'จากการรีวิวผลิตภัณฑ์',
        // default: 'Confirm to redeem',
        default_have_time: 'Serial will available for {0} after confirm',
        delivery: 'Please enter shipping information to redeem',
        free: 'Serial will available for {0} after confirm',
        free_no_timer: 'Confirm to redeem',
        free_delivery: 'Please enter shipping information to redeem',
        draw: 'Confirm to join campaign <br/> Winner will be announced after {0}',
        draw_delivery: 'Please enter shipping information to redeem',
        deal: 'Serial will available for {0} after confirm',
        deal_no_timer: 'Confirm to redeem',
        deal_delivery: 'Please enter shipping information to redeem',
        buy: 'Confirm to purchase',
        buy_delivery: 'Please enter shipping information to buy',
        interface: 'This will redirect to website after confirm',
    },
    purchase: {
        show_code: 'view code',
        code_expired: 'This serial has expired.',

        delivery: 'Product will be mailed based on Campaign Condition.',
        shipped: 'The Product has been delivered.',
        parcel_no: 'ParcelNo',

        privilege_shipped: 'จัดส่งเรียบร้อยแล้ว',
        privilege_delivery: 'อยู่ระหว่างจัดส่ง',
        privilege_prepare: 'กำลังเตรียมสินค้า',

        not_draw1: 'Not yet drawn,',
        not_draw2: 'please check back at a later date',
        draw_winner1: 'You are the winner',
        draw_winner2: '',
        draw_not_win1: 'Sorry you are not the winner,',
        draw_not_win2: 'better luck next',

        text_expired: 'Expired : ',
        unit_price: 'Baht',
    },
    serial: {
        close_btn: 'Close',
        default_privilege_message: 'As design',
        show_code_at_shop: 'Please show code below to claim your privilege',

        delivery: 'Product will be mailed based on Campaign Condition.',

        draw: 'Thank you for joining us.<br/>Winner will be announced after {0}',
        draw_after: 'after',

        qr_code: 'QR Code',
        barcode: 'Barcode',
        code: 'Code',

        copy_code: 'Copy Code',

        expire_in: 'Expire in ',
        code_expired: 'This serial has expired.',

        redeem_on: 'Redeem on {0}'
    },
    shipping: {
        headline: 'Shipping address',

        firstname: {
            name: 'Firstname',
            placeholder: 'Firstname',
            required: 'Please enter firstname',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'Lastname',
            placeholder: 'Lastname',
            required: 'Please enter lastname',
            too_short: '',
            invalid: '',
        },
        address: {
            name: 'Address',
            placeholder: 'Address',
            required: 'Please enter address',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            label: 'Contact number',
            placeholder: 'Contact number',
            required: 'Contact number',
            too_short: 'Contact number must be {0} digits',
            invalid: 'Incorrect contact number format',
        },
        nationalid: {
            name: 'National id',
            placeholder: 'National id',
            required: 'Please enter national id',
            too_short: 'National id number must be {0} digits',
            invalid: 'Incorrect national id format',
        },
        email: {
            name: 'Email',
            placeholder: 'Email',
            required: 'Please enter email address',
            too_short: '',
            invalid: 'Incorrect email format',
        },
        zipcode: {
            name: 'Zipcode',
            placeholder: 'Zipcode',
            required: 'Please enter zipcode',
            too_short: 'Zipcode must be {0} digits',
            invalid: 'Invalid zipcode',
        },
        subdistrict: {
            name: 'Sub district',
            placeholder: 'Please selece sub-district',
            required: 'Please selece sub-district',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'District',
            placeholder: 'Please selece district',
            required: 'Please selece district',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'Province',
            placeholder: 'Please selece province',
            required: 'Please selece province',
            too_short: '',
            invalid: '',
        },

        save_address: 'Save address for next privilege',
        save_address_buy: 'Save address for next puchase',

        confirm_btn: 'Confirm',
        cancel_btn: 'Cancel',

        alert_headline: 'Shipping address',
        alert_ok_btn: 'OK',

        modal_success: {
            title: 'คุณได้ทำการรับสิทธิ์เรียบร้อย',
            text_delivery: 'สินค้าจะจัดส่งให้คุณภายใน 15 วันทำการ',
            btn_view: 'ดูสิทธิพิเศษอื่นๆ',
        },

        draw_modal_success: {
            title: 'ขอบคุณที่ร่วมกิจกรรม',
            text: 'คุณสามารถตรวจสอบ<br/>การประกาศผลได้ที่หน้าประกาศผล',
            date: 'ในวันที่ 15 ก.ค. 65',
            btn_view: 'ลุ้นรางวัลอื่นๆ',
        }
    },
    confirm_delivery_address: {
        title: 'ยืนยันที่อยู่ในการจัดส่ง',
        sub_title: 'ที่อยู่ในการจัดส่งพัสดของคุณคือ..',
        change_address: 'เปลี่ยนที่อยู่ในการจัดส่ง',
    },
    main: {
        home_page: "Home",
        login: "Login",
        campaign: "Campaign",
        category: 'Category',
        map: "Map",
        terms: "Terms And Conditions",
        history: 'History',
        profile: "Profile",
        logout: "Logout",
        lang: "Language",
        msgLogout: "Logout ?",
        cancel: "Cancel",
        text_expire_point: 'มี {0} พอยท์จะหมดอายุวันที่ {1}',
    },
    campaign: {
        text_privilege: 'สิทธิพิเศษสำหรับคุณ',
        text_all: 'ดูทั้งหมด',
        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',
        unit_price: 'Baht',
        free: 'Free',
        use: 'Use',
        get: 'Get',
        see_detail: "See detail",
        add_to_cart: "Add to cart",
    },
    detail: {
        topbar_point_lbl: 'คุณมีพอยท์',
        detail: 'Details',
        condition: 'Conditions',

        point_unit: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',
        available_date: 'Date',
        expire_date: 'Expire date : {0}',

        color: {
            name: 'Color',
            placeholder: 'Please select color',
            required: 'Please select color',
        },
        size: {
            name: 'Size',
            placeholder: 'Please select size',
            required: 'Please select size',
        },
    },
    history: {
        page_title_earn: 'ประวัติการสะสมพอยท์',
        page_title_burn: 'ประวัติการแลกพอยท์',

        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',

        parcel_number: 'Parcel No. : ',
        month_year_form: {
            month: {
                name: '',
                defaultText: 'เดือน',
                required: ''
            },
            year: {
                name: '',
                defaultText: 'ปี',
                required: ''
            }
        },

        text_migrate_earn: 'โอน Points จากระบบเก่า',
    },
    login: {
        text_title: 'เข้าสู่ระบบ',
        contactnumber: {
            label: 'เบอร์โทรศัพท์',
            placeholder: 'กรอกเบอร์โทรศัพท์',
            required: 'กรุณากรอกเบอร์โทรศัพท์',
            too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
            invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
        },
        confirm_btn: 'ยืนยัน',
        text_skip: 'ข้าม'
    },
    verify_birthday: {
        title: 'เชื่อมต่อบัญชีผู้ใช้งาน',
        msg: 'กรุณากรอกวัน เดือน ปี เกิดของคุณเพื่อยืนยันตัวตน',
        birthdate: {
            name: 'วันเกิด',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: 'รูปแบบวันเกิดไม่ถูกต้อง',
            date: {
                name: '',
                defaultText: 'วัน',
                required: ''
            },
            month: {
                name: '',
                defaultText: 'เดือน',
                required: ''
            },
            year: {
                name: '',
                defaultText: 'ปี',
                required: ''
            },
        },
        modal_error: {
            title: 'ขออภัยไม่สามารถดำเนินการได้',
            error: 'Error code :',
            msg: 'กรุณาติดต่อ Admin ',
            line: 'https://page.line.me/?accountId=ovi0424j',
            btn_ok: 'Line: @Bioderma Thailand',
            btn_cancel: 'ปิด'
        }
    },
    otp:{
        title_otp: "ยืนยัน OTP",
        text_send_otp: "เราจะส่งรหัส OTP ไปยังหมายเลข ",
        text_enter_otp: "กรุณากรอกรหัส OTP",
        otp_timeout: "รหัส OTP จะหมดอายุภายใน",
        minute: "นาที",
        text_otp_expired: "รหัส OTP หมดอายุ",
        resend_otp: "ส่งอีกครั้ง",

        refcode: "Ref code : ",
        otpLength: "Please enter OTP Correctly",
        requireInput: "Please enter OTP Correctly",

        expiredOtp: "OTP has been expired, please request OTP once.",
        newOtp: "OTP has been sent successfully. ",
        failedOtp: "Failed to send OTP, Please try again later.",
        notCorrectOtp: "OTP is not correct, please try again.",
        otpAlertheadline: 'แจ้งเตือน',
        otpInvalid: "กรุณากรอก OTP ให้ถูกต้อง",

        btn_confirm: 'ยืนยัน',
    },
    modalProductList: {
        buyFrom: {
            name: 'ซื้อสินค้าจาก',
            placeholder: 'เลือกร้านค้า',
            required: 'กรุณาเลือกร้านค้า',
            too_short: '',
            invalid: '',
            defaultText: 'เลือกร้านค้า',
        otpInvalid: "กรุณากรอก OTP ให้ถูกต้อง",

        btn_confirm: 'ยืนยัน',
        },
        shopEarn: {
            name: '',
            placeholder: 'กรุณากรอกชื่อร้าน',
            required: 'กรุณากรอกชื่อร้าน',
            too_short: '',
            invalid: '',
        },
    },
    modalSkip: {
        collect_points: {
            title: 'การสะสมพอยท์',
            msg: 'หากคุณต้องการสะสมพอยท์<br/>กรุณาเข้าสู่ระบบ'
        },
        mission: {
            title: 'ภารกิจ',
            msg: 'หากคุณต้องการทำภารกิจ<br/>กรุณาเข้าสู่ระบบ'
        },
        redeem: {
            title: 'แลกรับสิทธิ์',
            msg: 'คุณต้องเข้าสู่ระบบก่อนแลกรับสิทธิ์'
        },
        btn_confirm: 'เข้าสู่ระบบ',
        btn_cancel: 'ยกเลิก'
    },
    topbar: {
        text_all_point: 'คุณมีพอยท์ทั้งหมด',
        text_expire_point: 'มี {0} พอยท์<br>จะหมดอายุวันที่ {1}',
        text_login: 'กรุณาเข้าสู่ระบบก่อนใช้งาน',
        text_btn_login: 'เข้าสู่ระบบ',
    },
    reward: {
        page_title: 'สิทธิพิเศษ',
    },
    pointGuide: {
        title: 'พอยท์แต่ละสินค้า',
    },
    text_nodata: 'ไม่พบข้อมูล',
    draw: {
        page_title: 'ลุ้นรางวัล'
    },
    modal_consent_age: {
        title: 'กรุณายืนยันอายุใหม่',
        msg: 'เนื่องจากการใช้งานแอปพลิเคชัน<br/>ต้องมีอายุมากกว่า 20 ปีบริบูรณ์',
        msg_detail: 'ฉันมีอายุ 20 ปีบริบูรณ์แล้ว',
        btn: 'ยืนยัน'
    }
};
